import { StreamlinesSession } from '../icons/StreamlinesSession';
import { StreamlinesRun } from '../icons/StreamlinesRun';
import { StreamlinesBicycle } from '../icons/StreamlinesBicycle';
import { StreamlinesRider } from '../icons/StreamlinesRider';
import { StreamlinesUser } from '../icons/StreamlinesUser';
import { StreamlinesAdmin } from '../icons/StreamlinesAdmin';
import { StreamlinesRoute } from '../icons/StreamlinesRoute';
import { StreamlinesReports } from '../icons/StreamlinesReports';
import { StreamlinesAdvanced } from '../icons/StreamlinesAdvanced';
import { StreamlinesStatistics } from '../icons/StreamlinesStatistics';
import CalibrationView from '../pages/CalibrationView/CalibrationView';
import SessionCalculatedData from '../pages/SessionView/SessionDetails/SessionCalculatedData/SessionCalculatedData';
import SessionList from '../pages/SessionList/SessionList';
import SessionView from '../pages/SessionView/SessionView';
import RunList from '../pages/RunList/RunList';
import RunView from '../pages/RunView/RunView';
import EquipmentList from '../pages/EquipmentList/EquipmentList';
import RunOverview from 'pages/RunView/RunDetails/RunDetails';
import RunPlotter from 'pages/RunView/RunPlotter/RunPlotter';
import RunAuxSensor from 'pages/RunView/RunAuxSensor/RunAuxSensor';
import AdminView from '../pages/AdminView/AdminView';
import EpisodesListView from '../pages/AdminView/EpisodesListView';
import EpisodeDetailView from '../pages/AdminView/EpisodeDetailView';
import AccountView from '../pages/AccountView/AccountView';
import RiderList from '../pages/RiderList/RiderList';
import RiderView from '../pages/RiderView/RiderView';
import StyleGuide from '../pages/StyleGuide/StyleGuide';
import { Navigate } from 'react-router-dom';
import SessionConfigs from '../pages/SessionView/SessionDetails/SessionConfigs/SessionConfigs';
import SessionCharts from '../pages/SessionView/SessionDetails/SessionCharts/SessionCharts';
import TyrePlots from '../pages/SessionView/SessionDetails/SessionCharts/TyrePlots';
import SessionBreakdown from '../pages/SessionView/SessionDetails/SessionBreakdown/SessionBreakdown';
import RequireFullSession from '../pages/SessionView/SessionDetails/RequireFullSession';
import RunHealthCheck from 'pages/RunView/RunHealthCheck/RunHealthCheck';
import RouteSelection from '../pages/RouteSelection/RouteSelection';
import GateFromRunPicker from '../pages/RouteSelection/GateFromRunPicker';
import RoutePicker from '../pages/RouteSelection/RoutePicker';
import SessionPicker from '../pages/SessionList/SessionPicker';
import RouteManagement from '../pages/RouteManagement/RouteManagement';
import TyreReports from '../pages/TyreReports/TyreReports';
import Statistics from '../pages/Statistics/Statistics';
import ModelsView from '../pages/ModelsView/ModelsView';
import DesignSystem from '../pages/DesignSystem/DesignSystem';
import { lazy, Suspense } from 'react';

const RunMap3D = lazy(() => import('pages/RunView/RunMap3D/RunMap3D'));
const RunDiagnostic = lazy(() => import('pages/RunView/RunDiagnostic/RunDiagnostic'));
const RunLapParsing = lazy(() => import('pages/RunView/RunLapParsing/RunLapParsing'));

export const SubRoutes = () => {
  const RunRoutes = [
    {
      path: 'overview',
      label: 'Overview',
      element: <RunOverview />,
    },
    {
      path: 'plotter',
      label: 'Plotter',
      element: <RunPlotter />,
    },
    {
      path: 'aux-sensor',
      label: 'Aux Sensor',
      element: <RunAuxSensor />,
    },
    {
      path: 'health-check',
      label: 'Health Check',
      element: <RunHealthCheck />,
    },
    {
      path: '3d-map',
      label: '3D Map',
      element: (
        <Suspense
          fallback={
            <div className="cr-flex cr-h-64 cr-items-center cr-justify-center">
              <div className="cr-text-gray-500">Loading 3D Map...</div>
            </div>
          }
        >
          <RunMap3D />
        </Suspense>
      ),
    },
    {
      path: 'lap-parsing',
      label: 'Lap Parsing',
      element: (
        <Suspense
          fallback={
            <div className="cr-flex cr-h-64 cr-items-center cr-justify-center">
              <div className="cr-text-gray-500">Loading Lap Parsing...</div>
            </div>
          }
        >
          <RunLapParsing />
        </Suspense>
      ),
    },
  ];

  return [
    {
      path: '/',
      element: <Navigate to="/sessions" />,
    },
    {
      path: '/sessions',
      label: 'Sessions',
      icon: <StreamlinesSession />,
      element: <SessionList />,
    },
    {
      path: '/sessions/:sessionId',
      label: 'Session',
      element: <SessionView />,
      nestedRoutes: [
        {
          path: '',
          element: <Navigate to="config" replace />,
        },
        {
          path: 'config',
          label: 'Configs',
          element: <SessionConfigs />,
        },
        {
          path: 'results',
          label: 'Calculations',
          element: <RequireFullSession><SessionCalculatedData /></RequireFullSession>,
        },
        {
          path: 'charts',
          label: 'Charts',
          element: <RequireFullSession><SessionCharts /></RequireFullSession>,
        },
        {
          path: 'tyre-plots',
          label: 'Tyre Plots',
          element: <RequireFullSession><TyrePlots /></RequireFullSession>,
        },
        {
          path: 'breakdown',
          label: 'Calculation',
          element: <RequireFullSession><SessionBreakdown /></RequireFullSession>,
        },
      ],
    },
    {
      path: '/runs',
      label: 'Runs',
      icon: <StreamlinesRun />,
      element: <RunList />,
    },
    {
      path: '/runs/:runId',
      label: 'Run Details',
      element: <RunView />,
      nestedRoutes: RunRoutes,
    },
    {
      path: '/sessions/:sessionId/runs/:runId',
      label: 'Run Details',
      element: <RunView />,
      nestedRoutes: RunRoutes,
    },
    {
      path: '/runs/:runId/diagnostic',
      label: 'Run Diagnostic',
      element: (
        <Suspense fallback={<div className="cr-flex cr-h-64 cr-items-center cr-justify-center"><div className="cr-text-gray-500">Loading...</div></div>}>
          <RunDiagnostic />
        </Suspense>
      ),
    },
    {
      path: '/sessions/:sessionId/runs/:runId/diagnostic',
      label: 'Run Diagnostic',
      element: (
        <Suspense fallback={<div className="cr-flex cr-h-64 cr-items-center cr-justify-center"><div className="cr-text-gray-500">Loading...</div></div>}>
          <RunDiagnostic />
        </Suspense>
      ),
    },
    {
      path: '/equipment',
      label: 'Equipment',
      element: <EquipmentList />,
    },
    {
      path: '/tyre-reports',
      label: 'Tyre-Reports',
      element: <TyreReports />,
    },
    {
      path: '/sessions/:sessionId/calibrations/:calibrationId',
      label: 'Calibrations',
      element: <CalibrationView />,
    },
    {
      path: '/calibrations/:calibrationId',
      label: 'Calibrations',
      element: <CalibrationView />,
    },
    {
      path: '/sessions/:sessionId/results',
      label: 'Session Calculated Data Results',
      element: <SessionCalculatedData />,
    },
    {
      path: '/team',
      label: 'Riders',
      icon: <StreamlinesRider />,
      element: <RiderList />,
    },
    {
      path: '/riders/:riderId',
      label: 'Rider',
      element: <RiderView />,
    },
    {
      path: '/advanced',
      label: 'Advanced',
      icon: <StreamlinesAdvanced />,
      submenu: [
        {
          path: '/equipment',
          label: 'Equipment',
          icon: <StreamlinesBicycle />,
        },
        {
          path: '/tyre-reports',
          label: 'Tyre-Reports',
          icon: <StreamlinesReports />,
        },
        {
          path: '/route-management',
          label: 'Routes',
          icon: <StreamlinesRoute />,
        },
        {
          path: '/statistics',
          label: 'Statistics',
          icon: <StreamlinesStatistics />,
        },
        {
          path: '/models',
          label: 'Models',
          icon: <StreamlinesAdvanced />,
        },
      ],
    },
    {
      path: '/route-management',
      label: 'Routes',
      element: <RouteManagement />,
    },
    {
      path: '/statistics',
      label: 'Statistics',
      element: <Statistics />,
    },
    {
      path: '/models',
      label: 'Models',
      element: <ModelsView />,
    },
    {
      path: '/account',
      label: 'Account',
      icon: <StreamlinesUser />,
      element: <AccountView />,
    },
    {
      path: '/admin',
      label: 'Admin',
      icon: <StreamlinesAdmin />,
      element: <AdminView />,
      userFilter: (user: any) => user.user_role >= 8000,
    },
    {
      path: '/admin/design-system',
      label: 'Design System',
      element: <DesignSystem />,
      userFilter: (user: any) => user.user_role >= 8000,
    },
    {
      path: '/admin/episodes',
      label: 'Episode DB Viewer',
      element: <EpisodesListView />,
      userFilter: (user: any) => user.user_role >= 8000,
    },
    {
      path: '/admin/episodes/detail/*',
      label: 'Episode Detail',
      element: <EpisodeDetailView />,
      userFilter: (user: any) => user.user_role >= 8000,
    },
    {
      path: '/style-guide',
      label: 'Style Guide',
      element: <StyleGuide />,
    },
    {
      path: '/route-selection',
      label: 'Route Selection',
      element: <RouteSelection />,
    },
    {
      path: '/gate-from-run',
      label: 'Create Gate from Run',
      element: <GateFromRunPicker />,
    },
    {
      path: '/route-picker',
      label: 'Route Picker',
      element: <RoutePicker />,
    },
    {
      path: '/session-picker',
      label: 'Session Picker',
      element: <SessionPicker />,
    },
  ];
};
